<template>
  <div class="" v-if="checkServiceIsExpire('basalam')">

    <div class="row">

      <div class="col text-right">
        <h5>
          تنظیمات محصول با سلام:
          {{ product.name }}
        </h5>
      </div>

      <div class="col text-left">
        <router-link class="btn rounded-pill btn-primary "
                     :to="{ name: 'EditProduct', params: { slug: product.raw_link } }">
          بازگشت به محصول
        </router-link>

      </div>

    </div>

    <div class="col-12">
      <basalam-product-status :basalamProduct="basalamProduct"/>
    </div>

    <form @submit.prevent="submit">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 my-2">
            <basalam-categories :basalamProduct="basalamProduct" :default-category="selectedCategory"
                                @category="setSelectedCategory"/>
          </div>

          <div class="col-lg-12 my-2" v-if="selectedCategory != null">
            <basalam-weight :basalamProduct="basalamProduct" :form-data="weight"/>
          </div>

          <div class="col-lg-12 my-2" v-if="false">
            <basalam-category-attributes :basalamProduct="basalamProduct" :category="selectedCategory"/>
          </div>
          <div class="col-lg-12 my-2">
            <div class="form-group">
              <label for="preparation_day">زمان آماده سازی(روز)</label>
              <input required type="number" min="1" v-model="preparation_days" class="form-control text-left"
                     id="preparation_day">
            </div>
          </div>
          <div class="row m-1">
            <div class="col-4 my-2">
              <label for="price_field">قیمت</label>
              <input type="number" id="price_field" required class="form-control text-left" v-model="primary_price"/>
              {{formatNumber(primary_price)}}
            </div>
            <div class="col-4 my-2">
              <label for="primary_price_field">قیمت با تخفیف</label>
              <input type="number" id="primary_price_field" required  class="form-control text-left"
                     v-model="price"
                     :max="primary_price"
                     />
              {{formatNumber(price)}}
            </div>
            <div class="col-4 my-2 ">
              <label for="myField">تعداد</label>
              <input type="number" id="myField" required class="form-control text-left" v-model="quantity"/>
            </div>
          </div>
          <div class="col-lg-12 my-2">
            <basalam-variation @variations="setSelectedVariations" :basalamProduct="basalamProduct"
                               :category="selectedCategory"/>
          </div>


        </div>
      </div>
      <div class="col-12 text-center mt-3">
        <button type="submit" class="btn btn-primary px-5 rounded-pill">
          ثبت
        </button>
      </div>
    </form>
  </div>
</template>

<script>

import BasalamCategories from "@/plugin/components/dashboard/Basalam/BasalamCategories/BasalamCategories.vue";
import BasalamCategoryAttributes
  from "@/plugin/components/dashboard/Basalam/BasalamCategoryAttributes/BasalamCategoryAttributes.vue";
import BasalamWeight from "@/plugin/components/dashboard/Basalam/BasalamWeight.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import BasalamVariation from "@/plugin/components/dashboard/Basalam/BasalamVariation.vue";
import BasalamProductStatus from "@/plugin/components/dashboard/Basalam/BasalamProductStatus.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {checkServiceIsExpire} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/SiteServiceManager";

export default {
  name: "ProductBasalamSetting.vue",
  components: {BasalamProductStatus, BasalamVariation, BasalamWeight, BasalamCategoryAttributes, BasalamCategories},
  data() {
    return {
      product: {},
      selectedCategory: null,
      basalamProduct: null,
      selectedVariations: [],
      price: 0,
      primary_price: 0,
      quantity: 0,
      weight: {
        weight: 0,
        package_weight: 0
      },
      preparation_days: 1,
    }
  },
  computed: {
    basalamProductId() {
      let productMeta = this.product.meta
      if (productMeta != undefined) {
        let basalamProductId = productMeta.find((item) => {
          return item.name === 'basalam_product_id';
        });
        return basalamProductId == undefined ? null : basalamProductId.value
      }
      return null
    },

  },
  methods: {
    checkServiceIsExpire,
    formatNumber,
    setSelectedCategory(category) {
      this.selectedCategory = category
    },
    priceTomanToReal(value) {

      if (value == null || value == '' || value == 0 || value.length == 0) {
        return 0
      }

      value = `${value}0`

      return parseInt(value)
    },
    priceRealToToman(value) {
      if (value == null || value == '' || value == 0 || value.length == 0) {
        return 0
      }
      value = parseInt(value)
      return value / 10
    },
    reshapeData(mode = 'create') {
      let form = {}

      if (mode == 'update') {
        form['id'] = this.basalamProductId
      }
      form['name'] = this.product.name
      form['photo'] = this.product.thumbnail
      form['category'] = this.selectedCategory.id

      // custom input
      form['weight'] = this.weight.weight
      form['package_weight'] = this.weight.package_weight

      // if our product was variation we don't have any below fields
      form['stock'] = this.quantity
      form['price'] = this.priceTomanToReal(this.price)
      form['primary_price'] = this.priceTomanToReal(this.primary_price)
      form['preparation_days'] = this.preparation_days

      form['description'] = ''
      form['attributes'] = []

      if (this.selectedVariations.length > 0) {
        let variations = []

        this.selectedVariations.forEach(item => {

          let tempItem = {
            value: item.properties[0].value_id.toString(),
            price: this.priceTomanToReal(item.price),
            primary_price: this.priceTomanToReal(item.primary_price),
            stock: item.stock,
          }

          if (item.property == 'color') {
            tempItem['property'] = 'color'
          }


          variations.push(tempItem)

        })

        form['variants'] = variations
      }

      return form
    },
    async submit() {
      let form;

      // validate category
      if (this.selectedCategory == null) {
        toast('هیچ دسته بندی انتخاب نشده است', 'هیچ دسته بندی انتخاب نشده است', 'danger')
        return false
      }

      form = this.reshapeData('create')

      if (this.basalamProductId == null) {
        form = this.reshapeData('create')

        let req = await this.$store.dispatch('Basalam/createProduct', form)

        let basalamForm = {
          id: this.product.id,
          basalam_product_id: req.data.data.id
        }

        await this.$store.dispatch('Basalam/setProductBasalam', basalamForm)

        location.reload();

      } else {
        form = this.reshapeData('update')
        await this.$store.dispatch('Basalam/updateProduct', form);
      }

    },
    async getBasalamProduct() {
      let form = {
        id: this.basalamProductId
      };

      let req = await this.$store.dispatch('Basalam/getProduct', form)
      return req.data.data
    },
    setSelectedVariations(data) {
      this.selectedVariations = data;
    },
    setPreparationDaysValue() {
      if (this.basalamProduct.revision != null) {
        this.preparation_days = this.basalamProduct.revision.data.preparation_day
      } else {
        this.preparation_days = this.basalamProduct.preparation_day
      }
    },
    setQuantityOfProduct() {
      this.quantity = this.basalamProduct.inventory
    },
  },
  async mounted() {
    await this.$store.dispatch("Product/getDashboardProduct", this.$route.params.slug)
        .then(async (res) => {

          res = res.data.data

          this.product = res
        })
        .catch((err) => {
          // this.$router.push({name: "ProductsDashboard"});
          console.log(err);
        });
  },
  watch: {
    basalamProductId: {
      async handler(newValue, oldValue) {
        if (newValue != null) {

          let basalamProduct = await this.getBasalamProduct();


          this.basalamProduct = basalamProduct
          this.selectedCategory = basalamProduct.category;
          this.setPreparationDaysValue()
          this.setQuantityOfProduct()

          this.price = this.priceRealToToman(this.basalamProduct.price)

          // set primary price

          this.primary_price = this.basalamProduct.primary_price == null ? this.price : this.priceRealToToman(this.basalamProduct.primary_price)

        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>

</style>